import { LoginModel, LoginResponse } from 'app/gamma/src/types';
import genericNormalizer from './generic';

export const normalizeLogin = genericNormalizer<LoginResponse, LoginModel>(
  ({ from }) => ({
    email: from('email'),
    id: from('id'),
    primary: from('primary'),
  }),
);
